import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

const SectionHeading = ({
  eyebrow,
  title,
  desc,
  align = 'left',
  action,
}: SectionHeadingProps) => (
  <div
    className={`mb-6 flex flex-col gap-4 md:mb-8 ${
      align === 'center'
        ? 'items-center text-center'
        : 'md:flex-row md:items-end md:justify-between'
    }`}
  >
    <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}>
      {eyebrow && (
        <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
          <i className="ri-flashlight-line text-[13px]"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-2 text-sm text-foreground-600 md:text-base">{desc}</p>}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export default SectionHeading;